import React from 'react';
import theme from './theme';
import { ThemeProvider } from '@mui/material/styles';
import { Route, BrowserRouter, Routes } from 'react-router-dom';
import Applications from './views/Applications';
import Login from './views/Login';
import { SnackbarProvider } from 'notistack';

function App() {
  return (
    <SnackbarProvider>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <Routes>
            <Route exact path="/statusViewer/" element={<Login />} />
            <Route exact path="/statusViewer/applications" element={<Applications />} />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </SnackbarProvider>
  );
}

export default App;
